// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__Iq3rR","filters_close":"FiltersBlock_filters_close__Zoryv"};